export default __webpack_public_path__ + "static/media/face-detection-and-recognition.80fcb22e.md";